import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const CareersPage = lazy(() => import('../pages/careers/page'));
const ResultsPage = lazy(() => import('../pages/results/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <CareersPage />
  },
  {
    path: '/results',
    element: <ResultsPage />
  },
  {
    path: '/admin/applications',
    element: <AdminPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
